// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import Label from '../../components/Label';
import SvgIconStyle from '../../components/SvgIconStyle';

// hooks
import useAuth from '../../hooks/useAuth';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking')
};

const useSideBar = () => {
  const {dashboardRules, userModules} = useAuth();

  const sidebarConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: 'general',
      items: [
        {
          title: 'app',
          path: PATH_DASHBOARD.root,
          icon: ICONS.dashboard
        },
      ]
    }
  ];

  const admin_menu:any = {
    subheader: 'Seguros',
    items: []
  }

  if(userModules && dashboardRules){
    if('Policy' in userModules) {
      const _module:any = {
        title: 'Pólizas',
        path: PATH_DASHBOARD.root,
        icon: ICONS.user,
        children: []
      }
  
      if('POLICY_ANY_LIST' in dashboardRules) {
        _module.children.push({ title: 'Lista', path: PATH_DASHBOARD.general.policies })
      }
  
      if('POLICY_ANY_CREATE' in dashboardRules) {
        _module.children.push({ title: 'Crear', path: PATH_DASHBOARD.general.policies })
      }
  
      admin_menu.items.push(_module)
    }
  
    if('Sport' in userModules) {
      const _module:any = {
        title: 'Deportes',
        path: PATH_DASHBOARD.root,
        icon: ICONS.user,
        children: []
      }
  
      if('SPORT_ANY_LIST' in dashboardRules) {
        _module.children.push({ title: 'Lista', path: PATH_DASHBOARD.general.sports })
      }
  
      if('SPORT_ANY_CREATE' in dashboardRules) {
        _module.children.push({ title: 'Crear', path: PATH_DASHBOARD.general.createSport })
      }
  
      admin_menu.items.push(_module)
    }
  
    if('Certificate' in userModules) {
      const _module:any = {
        title: 'Certificados',
        path: PATH_DASHBOARD.root,
        icon: ICONS.user,
        children: []
      }
  
      if('CERTIFICATE_ANY_LIST' in dashboardRules) {
        _module.children.push({ title: 'Lista', path: PATH_DASHBOARD.general.certificates })
      }
  
      if('CERTIFICATE_ANY_CREATE' in dashboardRules) {
        _module.children.push({ title: 'Crear', path: PATH_DASHBOARD.general.createCertificate })
      }
  
      admin_menu.items.push(_module)
    }
  
    if('Insured' in userModules) {
      const _module:any = {
        title: 'Asegurados',
        path: PATH_DASHBOARD.root,
        icon: ICONS.user,
        children: []
      }
  
      if('INSURED_ANY_LIST' in dashboardRules) {
        _module.children.push({ title: 'Lista', path: PATH_DASHBOARD.general.insureds })
      }
  
      if('INSURED_ANY_CREATE' in dashboardRules) {
        _module.children.push({ title: 'Crear', path: PATH_DASHBOARD.general.createInsured })
      }
  
      admin_menu.items.push(_module)
    }
  
    if('Product' in userModules) {
      const _module:any = {
        title: 'Productos',
        path: PATH_DASHBOARD.root,
        icon: ICONS.user,
        children: []
      }
  
      if('PRODUCT_ANY_LIST' in dashboardRules) {
        _module.children.push({ title: 'Lista', path: PATH_DASHBOARD.general.products })
      }
  
      if('PRODUCT_ANY_CREATE' in dashboardRules) {
        _module.children.push({ title: 'Crear', path: PATH_DASHBOARD.general.createProduct })
      }
  
      admin_menu.items.push(_module)
    }
  }

  sidebarConfig.push(admin_menu)

  if(dashboardRules) {
    if('SURA_LIST' in dashboardRules || 'ZURICH_LIST' in dashboardRules) {
      const insurers:any = {
        subheader: 'Aseguradoras',
        items: []
      }
      
      if('ZURICH_LIST' in dashboardRules)
       insurers.items.push({
          title: 'ZURICH',
          path: PATH_DASHBOARD.root,
          icon: ICONS.cart,
          children: [{ title: 'Asegurados', path: PATH_DASHBOARD.insurers.zurich }]
        })

      if('SURA_LIST' in dashboardRules)
        insurers.items.push({
           title: 'SURA',
           path: PATH_DASHBOARD.root,
           icon: ICONS.cart,
           children: [{ title: 'Asegurados', path: PATH_DASHBOARD.insurers.sura }]
         })
    
      sidebarConfig.push(insurers)
    }
  }

  return {
    sidebarConfig
  }
}

export default useSideBar;
